import { render, staticRenderFns } from "./Admisionfactura.vue?vue&type=template&id=c2df813a"
import script from "./Admisionfactura.vue?vue&type=script&lang=js"
export * from "./Admisionfactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports